import React from "react";
import { BrowserRouter, Switch, Route } from "react-router-dom";

import definedRoutes from "./routes";
import { PrivateRoute } from "./modules/auth/components/PrivateRoute";
import { AuthDataProvider } from "./modules/auth";
import { SignInPage } from "./modules/auth/pages/SignInPage";
import { MessagePage } from "./modules/layout/MessagePage";
import { ForgottenPasswordPage } from "./modules/auth/pages/ForgottenPassword";

function App({ routes = definedRoutes }) {
  return (
    <AuthDataProvider>
      <BrowserRouter>
        <Switch>
          {routes.map(
            ({ path, Component, requiredPermission, ...props }, index) => (
              <PrivateRoute
                key={index}
                exact
                path={path}
                component={Component}
                requiredPermission={requiredPermission}
                {...props}
              />
            )
          )}
          <Route exact path="/signin" component={SignInPage} />
          <Route
            exact
            path="/forgotten-password"
            component={ForgottenPasswordPage}
          />
          <Route
            render={(props) => (
              <MessagePage
                message="Sorry, that page could not be found"
                {...props}
              />
            )}
          />
        </Switch>
      </BrowserRouter>
    </AuthDataProvider>
  );
}
export default App;
